/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
//Password validation
export const validatePassword = (password: string): string => {
	if (!password) return '';

	if (password.length < 8) {
		return 'Password must be at least 8 characters long';
	}

	if (password.length > 32) {
		return 'Password should be less than or equal to 32 characters';
	}

	if (!/[A-Z]/.test(password)) {
		return 'Password must contain at least one uppercase letter';
	}

	if (!/[a-z]/.test(password)) {
		return 'Password must contain at least one lowercase letter';
	}

	if (!/[0-9]/.test(password)) {
		return 'Password must contain at least one number';
	}

	if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
		return 'Password must contain at least one special character';
	}

	return ''; // ✅ valid
};

// // 📧 Email validation (live + submit safe)
// export const validateEmail = (email: string): string => {
//   if (!email) return '';

//   if (!email.includes('@')) {
//     return 'Please enter a valid email address';
//   }

//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   if (!emailRegex.test(email)) {
//     return 'Please enter a valid email address';
//   }

//   return ''; // ✅ valid
// };
interface EmailValidationResult {
	isValid: boolean;
	errorMessage: string;
}

// 🔐 Core email validator (your strong logic)
export const validateEmailDetailed = (email: string): EmailValidationResult => {
	if (email.trim() === '') {
		return { isValid: false, errorMessage: 'Your email, please!' };
	}

	if (
		email !== email.trim() ||
		email.startsWith('+') ||
		email.startsWith('.') ||
		email.startsWith('-') ||
		email.startsWith('_') ||
		email.endsWith('.') ||
		email.endsWith('-') ||
		email.endsWith('_')
	) {
		return {
			isValid: false,
			errorMessage:
				'Email cannot have leading or trailing special characters.',
		};
	}

	if (!email.includes('@')) {
		return {
			isValid: false,
			errorMessage: 'Email must contain an @ symbol.',
		};
	}

	if ((email.match(/@/g) || []).length > 1) {
		return {
			isValid: false,
			errorMessage: 'Email cannot contain multiple @ symbols.',
		};
	}

	const parts = email.split('@');
	if (parts.length !== 2 || !parts[1]) {
		return {
			isValid: false,
			errorMessage: 'Email must contain a valid domain.',
		};
	}

	const validEmailRegex = /^[A-Za-z0-9._\-+@]+$/;
	if (!validEmailRegex.test(email)) {
		return {
			isValid: false,
			errorMessage:
				'Email can only contain letters, numbers, and . _ - +',
		};
	}

	const localPart = parts[0];
	const domain = parts[1];

	if (localPart.startsWith('.') || localPart.endsWith('.')) {
		return {
			isValid: false,
			errorMessage: 'Local part of email cannot start or end with a dot.',
		};
	}

	if (domain.startsWith('.') || domain.endsWith('.')) {
		return {
			isValid: false,
			errorMessage: 'Domain cannot start or end with a dot.',
		};
	}

	if (localPart.includes('..') || domain.includes('..')) {
		return {
			isValid: false,
			errorMessage: 'Email cannot contain consecutive dots.',
		};
	}

	if (!domain.includes('.')) {
		return {
			isValid: false,
			errorMessage: 'Email domain must contain at least one dot.',
		};
	}

	const domainParts = domain.split('.');
	if (domainParts[domainParts.length - 1].length < 2) {
		return {
			isValid: false,
			errorMessage: 'Domain extension must have at least two characters.',
		};
	}

	return { isValid: true, errorMessage: '' };
};

// 🧠 UI-friendly wrapper (MATCHES your current usage)
export const validateEmail = (email: string): string => {
	const { isValid, errorMessage } = validateEmailDetailed(email);
	return isValid ? '' : errorMessage;
};

// 🔁 Password match validation
export const validatePasswordMatch = (
	password: string,
	rePassword: string
): string => {
	if (!rePassword) return '';

	const passwordSlice = password.slice(0, rePassword.length);

	if (passwordSlice !== rePassword) {
		return 'Passwords do not match';
	}

	return '';
};

export const validateFullName = (
	name: string
): { isValid: boolean; errorMessage: string } => {
	// Trim any leading or trailing spaces first
	const trimmedName = name.trim();

	if (trimmedName === '') {
		return {
			isValid: false,
			errorMessage: 'A blank name? We are not ready for this.',
		};
	}

	// Check for leading or trailing spaces after trimming
	// if (name !== trimmedName) {
	//     return { isValid: false, errorMessage: 'Name cannot have leading or trailing spaces.' };
	// }

	// Ensure name is at least 3 characters and not too long
	if (trimmedName.length < 1) {
		return {
			isValid: false,
			errorMessage: 'Name must be at least 1 characters long.',
		};
	}

	if (trimmedName.length > 100) {
		// Extended limit for longer names
		return {
			isValid: false,
			errorMessage: 'Name cannot exceed 100 characters.',
		};
	}

	// Validate characters (allow letters, spaces, hyphens, apostrophes, periods, and commas)
	const validCharRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s\-'.,]+$/; // Added accented characters
	if (!validCharRegex.test(trimmedName)) {
		return {
			isValid: false,
			errorMessage:
				'Name can only contain letters, spaces, hyphens, apostrophes, periods, or commas.',
		};
	}

	// Check if the name starts with a number or special character
	const firstChar = trimmedName[0];
	const invalidStartRegex = /^[0-9\W_]/; // Disallow numbers or special characters at the beginning
	if (invalidStartRegex.test(firstChar)) {
		return {
			isValid: false,
			errorMessage:
				'Name cannot start with a number or special character.',
		};
	}

	// Check for consecutive spaces, hyphens, apostrophes, or periods
	if (
		/\s{2,}/.test(trimmedName) ||
		/--/.test(trimmedName) ||
		/''/.test(trimmedName) ||
		/\.\./.test(trimmedName)
	) {
		return {
			isValid: false,
			errorMessage:
				'Name cannot contain consecutive spaces, hyphens, apostrophes, or periods.',
		};
	}

	// Count spaces, hyphens, apostrophes, and periods
	// const spaces = (trimmedName.match(/\s/g) || []).length;
	const hyphens = (trimmedName.match(/-/g) || []).length;
	const apostrophes = (trimmedName.match(/'/g) || []).length;
	const periods = (trimmedName.match(/\./g) || []).length;

	// Name can contain up to 3 spaces, 2 hyphens, 2 apostrophes, and 1 period
	// if (spaces > 3) {
	//     return { isValid: false, errorMessage: 'Name cannot contain more than 3 spaces.' };
	// }

	if (hyphens > 2) {
		return {
			isValid: false,
			errorMessage: 'Name cannot contain more than 2 hyphens.',
		};
	}

	if (apostrophes > 2) {
		return {
			isValid: false,
			errorMessage: 'Name cannot contain more than 2 apostrophes.',
		};
	}

	if (periods > 1) {
		return {
			isValid: false,
			errorMessage: 'Name can contain at most 1 period.',
		};
	}

	// Allowing initials with periods (e.g., "John D. Smith")
	const parts = trimmedName.split(/\s+/); // Split by spaces
	for (let part of parts) {
		// Initials should be a single letter followed by a period, e.g., "J." or "J.S."
		if (
			part.length === 2 &&
			part[1] === '.' &&
			part[0].toUpperCase() === part[0]
		) {
			continue; // valid initial (like "J." or "D.S.")
		}

		// Ensure each part of the name starts with an uppercase letter
		// if (part[0] !== part[0].toUpperCase()) {
		//     return { isValid: false, errorMessage: 'Each part of the name should start with an uppercase letter.' };
		// }
	}

	return { isValid: true, errorMessage: '' };
};
export const validateFullNameUI = (name: string): string => {
	const { isValid, errorMessage } = validateFullName(name);
	return isValid ? '' : errorMessage;
};

export const syncPasswordMatchError = (
	password: string,
	rePassword: string
): string => {
	if (!rePassword) return '';

	// First: run your existing progressive validation
	const partialMatchError = validatePasswordMatch(password, rePassword);
	if (partialMatchError) return partialMatchError;

	// Second: ensure full equality once both are typed
	if (password !== rePassword) {
		return 'Passwords do not match';
	}

	return '';
};
export const validateOrganizationName = (name: string): string => {
	const trimmed = name.trim();

	if (!trimmed) return ''; // optional field

	if (trimmed.length < 2) {
		return 'Organization name must be at least 2 characters';
	}

	if (trimmed.length > 100) {
		return 'Organization name cannot exceed 100 characters';
	}

	// Allow letters, numbers, spaces, &, ., -, ,
	const regex = /^[A-Za-z0-9\s&.,-]+$/;

	if (!regex.test(trimmed)) {
		return 'Only letters, numbers, spaces and & . , - are allowed';
	}

	// No consecutive spaces or symbols
	if (/\s{2,}/.test(trimmed)) {
		return 'No multiple consecutive spaces allowed';
	}

	return '';
};
export const validateLocation = (location: string): string => {
	const trimmed = location.trim();

	if (!trimmed) return ''; // optional field

	if (trimmed.length < 2) {
		return 'Location must be at least 2 characters';
	}

	if (trimmed.length > 80) {
		return 'Location cannot exceed 80 characters';
	}

	// Allow city/state/country names
	const regex = /^[A-Za-z\s,.-]+$/;

	if (!regex.test(trimmed)) {
		return 'Location can only contain letters, spaces, comma, . and -';
	}

	if (/\s{2,}/.test(trimmed)) {
		return 'No multiple consecutive spaces allowed';
	}

	return '';
};
